<template>
  <div>
    <v-progress-linear
      indeterminate
      color="primary"
      v-show="loading"
    ></v-progress-linear>
    <br />
    <v-row>
      <v-col cols="8"
        ><v-btn :disabled="loading" flat color="primary" @click="publishGoods()"
          >Опубликовать товары</v-btn
        ></v-col
      >
      <v-col cols="4"
        ><v-text-field
          v-model="search"
          label="Найти товар"
          :prepend-inner-icon="'$mdiMagnify'"
          variant="outlined"
          hide-details
          single-line
        ></v-text-field
      ></v-col>
    </v-row>
    <v-data-table
      :headers="headers"
      :items="goods"
      class="elevation-1"
      height="300px"
      fixed-header
      v-model:page="page"
      v-model="selected"
      show-select
      selectable-key="isSelectable"
      :search="search"
      :items-per-page="itemsPerPage"
    >
      <template v-slot:top>
        <v-text-field
          :model-value="itemsPerPage"
          class="pa-2"
          label="Кол-во товаров на странице"
          type="number"
          hide-details
          @update:model-value="itemsPerPage = parseInt($event, 10)"
        ></v-text-field>
      </template>
      <template v-slot:item.isPublished="{ item }">
        <td>
          <span>
            <v-icon
              icon="$mdiCheck"
              v-if="item.props.title.isPublished"
              color="success"
              v-bind="props"
            />
          </span>
        </td>
      </template>
      <template v-slot:bottom>
        <div class="text-center pt-2">
          <v-pagination v-model="page" :length="pageCount"></v-pagination>
        </div>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
const SupplierGoodsStockRepository =
  RepositoryFactory.get("supplierGoodsStock");

export default {
  props: ["category", "supplier"],
  components: {},
  data() {
    return {
      goods: [],
      loading: false,
      headers: [
        {
          title: "Наименование",
          align: "start",
          sortable: false,
          key: "name",
        },
        {
          title: "Цена",
          align: "start",
          sortable: false,
          key: "price",
        },
        {
          title: "Цена в рублях",
          align: "start",
          sortable: false,
          key: "priceRub",
        },
        {
          title: "Товары на складе поставщика",
          align: "start",
          sortable: false,
          key: "inStock",
        },
        {
          title: "Товары в резерве поставщика",
          align: "start",
          sortable: false,
          key: "inReserve",
        },
        {
          title: "Валюта цены",
          align: "start",
          sortable: false,
          key: "priceCurrency",
        },
        {
          title: "Цена дилера",
          align: "start",
          sortable: false,
          key: "dilerPrice",
        },
        {
          title: "Цена дилера в рублях",
          align: "start",
          sortable: false,
          key: "dilerPriceRUB",
        },
        {
          title: "Валюта дилера",
          align: "start",
          sortable: false,
          key: "dilerCurrency",
        },
        {
          title: "Товар связанный",
          align: "start",
          sortable: false,
          key: "isPublished",
        },
      ],
      options: {},
      selected: [],
      search: "",
      page: 1,
      itemsPerPage: 100,
    };
  },
  mounted() {
    this.list();
  },
  watch: {},
  methods: {
    async list() {
      this.loading = true;
      const result = await SupplierGoodsStockRepository.getCategoryGoods(
        this.category.id
      );

      if (result && result.data.status === "success") {
        this.goods = result.data.data;
      }
      this.loading = false;
    },
    async publishGoods() {
      const productsForPublish = this.selected.map((x) => {
        return {
          stockProductId: x,
          selectedRelationProductId: 0,
        };
      });
      this.loading = true;
      await SupplierGoodsStockRepository.publishGoods(
        this.category.id,
        productsForPublish,
        false
      );
      await this.list();
      this.selected = [];
      this.loading = false;
    },
  },
  computed: {
    pageCount() {
      return Math.ceil(this.goods.length / this.itemsPerPage);
    },
  },
};
</script>
